import { Component, ElementRef, HostListener, Inject, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { EventEmitter } from 'events';
import { AppConstants } from 'src/services/AppConstants';
import { LOCAL_STORAGE } from 'ngx-webstorage-service';
import { MasterService } from 'src/services/master.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sales-price',
  templateUrl: './sales-price.component.html',
  styleUrls: ['./sales-price.component.css']
})
export class SalesPriceComponent implements OnInit {
  sideNavStatus:boolean =false;
  itemData: any;
  partyData: any;
  customerLogin: boolean;
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == "Escape") {
      this.dialog.closeAll();
      this.openComponent('dashboard/master')
    }
  }
  openComponent(component: string) {
    this.router.navigate(['/' + component]);
  }
  @ViewChild('newSalesPriceForm') newSalesPriceForm!: TemplateRef<any>;
  @ViewChild('content') content: ElementRef;
  @Output() public emitData = new EventEmitter();
  showErrorAlert: boolean = false;
  isEditFlow: boolean = false;
  isDeleteFlow: boolean = false;
  forView: boolean = true;
  passData: any;
  isLoading: boolean = false;
  data!: any;
  salesPriceFormData: any;


  salesPriceForm = this.fb.group({
    'partyLabel': ['', Validators.required],
    'itemNameLabel': ['', Validators.required],
    'salesRateLabel': ['', Validators.required],
    'discountLabel': ['', Validators.required],
    'partNoLabel': ['', Validators.required],
  });
  code: any;

  ;
  constructor(private fb: FormBuilder, private router: Router,
    private masterService: MasterService,
    private dialog: MatDialog,
    private appConstants: AppConstants,
    @Inject(LOCAL_STORAGE) public storage,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.resetSalesPriceForm();
    this.getSalesPriceData();
    console.clear()
    if(sessionStorage.getItem('customerLogin')=="true"){
      this.customerLogin=true;
    }else{
      this.customerLogin=false;
    }
  }
  getSalesPriceData() {
    this.isLoading = false;
    let listOfItems = ['SalesPrice', 'Item', 'Ledger'];
    let optionValList = ['0', '0', '1'];
    this.masterService.getItem(listOfItems, optionValList).subscribe(response => {
      this.toastr.info("Data Retrived Successfully", "Data Retrive Message")
      this.salesPriceFormData = response.salesPrice0;
      this.itemData = response.item0;
      this.partyData = response.ledger1;
      this.passData = [this.appConstants.salesPriceFormColumnNames, this.salesPriceFormData, 'salesPriceForm', this.appConstants.salesPriceExcelColumnNames];
      this.isLoading = true;
    },
      (error => {
        this.passData = [this.appConstants.salesPriceFormColumnNames, false, 'salesPriceForm'];
        this.isLoading = true;
        this.toastr.error("Unable To Retrieve Data", "Data Retrieve Error");
      })
    );
  }

  resetSalesPriceForm() {
    this.showErrorAlert = false;
    this.salesPriceForm = this.fb.group({
      'partyLabel': ['', Validators.required],
      'itemNameLabel': ['', Validators.required],
      'salesRateLabel': ['', Validators.required],
      'discountLabel': ['', Validators.required],
      'partNoLabel': ['', Validators.required],
    });
  }

  addSalesPrice(rowData?: any) {
    if (this.salesPriceForm.invalid) {
      this.showErrorAlert = true;
    } else {
      this.showErrorAlert = false;
      this.isLoading = false;
      const generatedData = {
        Serial: sessionStorage.getItem("Serial"),
        Rate: this.salesPriceForm.controls['salesRateLabel'].value,
        DiscountPer: this.salesPriceForm.controls['discountLabel'].value,
        PartNo: this.salesPriceForm.controls['partNoLabel'].value,
        CompanyCode: sessionStorage.getItem("CompanyCode"),
        ServerVal: sessionStorage.getItem("ServerVal"),
        Code: !this.isEditFlow ? '' : this.code,
        ACode: this.salesPriceForm.controls['partyLabel'].value,
        ICode: this.salesPriceForm.controls['itemNameLabel'].value,//need to confirm
        MName: 'Sales Price'
      }
      this.dialog.closeAll();
      if (this.isEditFlow) {
        this.masterService.updateSalesPrice(generatedData).subscribe(response => {
          this.getSalesPriceData();
          this.toastr.success("Data Updated Successfully", "Update Success")
        },
          (error => {
            this.isLoading = true;
            this.toastr.error("Unable To Update Data", "Update Error");
          })
        );
      } else {
        this.masterService.addNewSalesPrice(generatedData).subscribe(response => {
          this.getSalesPriceData()
          this.toastr.success("Data added Successful", "Add Success");
        },
          (error => {
            this.isLoading = true;
            this.toastr.error("Unable To Add New Data", "Add Error");
          })
        );
      }
    }
  }

  addNewSalesPrice(rowData?: any) {
    this.resetSalesPriceForm();
    if (rowData === null || rowData === undefined) {
      this.code = '';
      this.forView = true
      this.isEditFlow = false;
      let dialogRef = this.dialog.open(this.newSalesPriceForm, {
        disableClose: true,
        minWidth: '60%'
      });
      dialogRef.afterClosed().subscribe(result => { });
    } else if ((rowData != null || rowData != undefined) && rowData.editFlow && (rowData.row.isMain == 0)) {
      this.isEditFlow = rowData.editFlow ? true : false;
      this.forView = true
      this.patchSalesPriceFormValues(rowData.row);
      this.code = rowData.row.code;
      let dialogRef = this.dialog.open(this.newSalesPriceForm, {
        disableClose: true,
        minWidth: '60%'
      });
      dialogRef.afterClosed().subscribe(result => { });
    } else if ((rowData != null || rowData != undefined) && rowData.deleteFlow) {
      this.isDeleteFlow = rowData.deleteFlow ? true : false;
      this.isLoading = false;
      const generatedData = {
        Serial: sessionStorage.getItem("Serial"),
        CompanyCode: sessionStorage.getItem("CompanyCode"),
        ServerVal: sessionStorage.getItem("ServerVal"),
        Code: rowData.row.code,
        MName: 'Sales Price'
      }
      this.masterService.deleteSalesPrice(generatedData).subscribe(response => {
        this.isLoading = true;
        this.toastr.success("Deleted Successfully", "Delete Success", {
          closeButton: true,
          
        });
        this.getSalesPriceData();
      },
        (error => {
          this.isLoading = true;
          this.toastr.error("Unable to Delete Data", "Delete Unsuccess", {
            closeButton: true,
            
          });
          this.getSalesPriceData();
        })
      );
    } else if ((rowData != null || rowData != undefined) && rowData.editFlow && (rowData.row.isMain != 0)) {
      this.toastr.warning("You don't have sufficient privilege to Edit this Data", "Edit Alert")
    } else if ((rowData != null || rowData != undefined) && rowData.viewFlow) {
      this.forView = false
      this.patchSalesPriceFormValues(rowData.row);
      this.code = rowData.row.code;
      let dialogRef = this.dialog.open(this.newSalesPriceForm, {
        disableClose: true,
        minWidth: '60%'
      });
      dialogRef.afterClosed().subscribe(result => { });
    }
  }

  patchSalesPriceFormValues(row) {
    this.salesPriceForm.patchValue({
      'serialNoLabel': row.serial,
      'partyLabel': row.aCode,
      'itemNameLabel': row.iCode,
      'salesRateLabel': row.rate,
      'discountLabel': row.discountPer,
      'partNoLabel': row.partNo,
    })
  }
}


